import styled from 'styled-components'

export const FullHeightContainer = styled.div`
  height: 100%;
`
